export function sortRoles(roles: string[]) : string[] {
    return roles
      .sort((a, b) => a.localeCompare(b));
}